import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import CancelTokenStore from "./CancelTokenStore";
import LoadingStore from "./LoadingStore";
import UrlBuilderStore from "./UrlBuilderStore";
import ErroStore from "./ErroStore";
import UsuarioStore from "./UsuarioStore";
import CoreStore from "./CoreStore";
import HeaderStore from "./HeaderStore";
import FiltroStore from "./FiltroStore";
import VersaoStore from "./VersaoStore";
import ObservacaoStore from "./ObservacaoStore";
import SucessoStore from "./SucessoStore";
import ConfirmarStore from "./ConfirmarStore";
import PrestadorStore from "./PrestadorStore";

import FormularioStore from "./FormularioStore/index.js";
import ValidacaoStore from "./ValidacaoStore";
import ApsStore from "./ApsStore";

export default new Vuex.Store({
  modules: {
    CancelTokenStore,
    LoadingStore,
    UrlBuilderStore,
    ErroStore,
    UsuarioStore,
    CoreStore,
    HeaderStore,
    FiltroStore,
    VersaoStore,
    ObservacaoStore,
    SucessoStore,
    ConfirmarStore,
    FormularioStore,
    ValidacaoStore,
    ApsStore,
    PrestadorStore
  }
});
